import { PartialType } from '../../../utils';
import { CreateD2CRefundPolicyDto } from './create-d2c-refund-policy.dto';
export class UpdateD2CRefundPolicyDto extends PartialType(CreateD2CRefundPolicyDto) {
}
